module.exports = __webpack_public_path__ + "img/newsletterTemplates.4e7fe76b.svg";